import React from 'react';
import { useNavigate } from 'react-router-dom';
//  ĐÈN
import taybac from '../img/den/taybac.png';
import hue from '../img/den/hue.png';
import taynguyen from '../img/den/taynguyen.png';
import baclieu from '../img/den/baclieu.png';
import canthoDen from '../img/den/cantho.png';
import dongthapDen from '../img/den/dongthap.png';
import haugiang from '../img/den/haugiang.png';
import longan from '../img/den/longan.png';
import tiengiangDen from '../img/den/tiengiang.png';
import travinhDen from '../img/den/travinh.png';
import vinhlongDen from '../img/den/vinhlong.png';

//  TINH DẦU
import canthoTD from '../img/tinhdau/cantho.png';
import dongthapTD from '../img/tinhdau/dongthap.png';
import nhatrang from '../img/tinhdau/nhatrang.png';
import tiengiangTD from '../img/tinhdau/tiengiang.png';
import travinhTD from '../img/tinhdau/travinh.png';
import vinhlongTD from '../img/tinhdau/vinhlong.png';

import td1 from '../img/td1.jpg';

const products = [
  // 🌿 ĐÈN
  { id: 1, name: 'Đèn Memory Tây Bắc', desc: 'Mang cảm hứng núi rừng Tây Bắc với họa tiết thổ cẩm độc đáo.', img: taybac, type: 'den' },
  { id: 2, name: 'Đèn Memory Huế', desc: 'Phản chiếu nét trầm lắng và cổ kính của đất cố đô.', img: hue, type: 'den' },
  { id: 3, name: 'Đèn Memory Tây Nguyên', desc: 'Ấm áp, mạnh mẽ với hoa văn gốm đặc trưng vùng cao nguyên.', img: taynguyen, type: 'den' },
  { id: 4, name: 'Đèn Memory Bạc Liêu', desc: 'Tinh tế và duyên dáng, lấy cảm hứng từ vùng đất đờn ca tài tử.', img: baclieu, type: 'den' },
  { id: 5, name: 'Đèn Memory Cần Thơ', desc: 'Tươi sáng, mang nét bình dị của miền sông nước Tây Đô.', img: canthoDen, type: 'den' },
  { id: 6, name: 'Đèn Memory Đồng Tháp', desc: 'Nhẹ nhàng và thanh thoát như những đóa sen hồng Đồng Tháp.', img: dongthapDen, type: 'den' },
  { id: 7, name: 'Đèn Memory Hậu Giang', desc: 'Phản ánh vẻ đẹp giản dị, ấm áp của miền quê Nam Bộ.', img: haugiang, type: 'den' },
  { id: 8, name: 'Đèn Memory Long An', desc: 'Sự kết hợp hài hòa giữa truyền thống và hiện đại.', img: longan, type: 'den' },
  { id: 9, name: 'Đèn Memory Tiền Giang', desc: 'Đậm chất sông nước miệt vườn, mang hơi thở thiên nhiên.', img: tiengiangDen, type: 'den' },
  { id: 10, name: 'Đèn Memory Trà Vinh', desc: 'Mang nét giao hòa văn hóa Khmer và Việt, độc đáo và sâu lắng.', img: travinhDen, type: 'den' },
  { id: 11, name: 'Đèn Memory Vĩnh Long', desc: 'Tươi sáng, đậm chất miền Tây trù phú và thân thiện.', img: vinhlongDen, type: 'den' },

  // 🌸 TINH DẦU
  { id: 12, name: 'Tinh Dầu Cần Thơ', desc: 'Hương thơm nhẹ nhàng, giúp thư giãn tinh thần sau ngày dài.', img: canthoTD, type: 'tinhdau' },
  { id: 13, name: 'Tinh Dầu Đồng Tháp', desc: 'Chiết xuất từ sen và thảo mộc, mang hương đồng nội mộc mạc.', img: dongthapTD, type: 'tinhdau' },
  { id: 14, name: 'Tinh Dầu Nha Trang', desc: 'Mùi biển dịu mát kết hợp với thảo mộc vùng duyên hải.', img: nhatrang, type: 'tinhdau' },
  { id: 15, name: 'Tinh Dầu Tiền Giang', desc: 'Ngọt ngào và dễ chịu, chiết xuất từ vỏ cam và bưởi miền Tây.', img: tiengiangTD, type: 'tinhdau' },
  { id: 16, name: 'Tinh Dầu Trà Vinh', desc: 'Mùi hương thanh khiết từ sả chanh giúp khử mùi và xua muỗi.', img: travinhTD, type: 'tinhdau' },
  { id: 17, name: 'Tinh Dầu Vĩnh Long', desc: 'Tinh túy từ thiên nhiên, mang lại cảm giác thư giãn sâu.', img: vinhlongTD, type: 'tinhdau' },
];

// Component nhận prop productType từ App.js (mặc định 'all' để hiện hết)
const Products = ({ productType = 'all' }) => {
  // Filter sản phẩm dựa trên type
  const filteredProducts = productType === 'all' 
    ? products  // Hiện hết nếu 'all'
    : products.filter(p => p.type === productType);  // Lọc theo 'den' hoặc 'tinhdau'

  // Đổi title động dựa trên filter
  const title = productType === 'den' 
    ? 'Đèn Xông Tinh Dầu' 
    : productType === 'tinhdau' 
      ? 'Tinh Dầu' 
      : 'Sản Phẩm Của Chúng Tôi';

  const navigate = useNavigate();

  return (
    <section id="products" className="products-section">
      <h2 className="section-title">{title}</h2>
      <div className="products-grid">
        {filteredProducts.map((item) => (
          <div key={item.id} className="product-card">
            <img src={item.img} alt={item.name} className="product-image" />
            <h3>{item.name}</h3>
            <p style={{ color: '#000', fontStyle: 'italic', textAlign: 'left' }}>{item.desc}</p>
            <div style={{ color: '#FF0000', fontStyle: 'italic'  }} className="product-price">Coming Soon</div>
            <button className="product-button" onClick={() => navigate(`/san-pham/chi-tiet/${item.id}`)}>Chi Tiết</button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Products;